'use client';

import Header from '@/components/common/Header';
import IntroStatement from './components/IntroStatement';
import HistoricalDataComparison from './components/HistoricalDataComparison';
import InvestmentCalculator from './components/InvestmentCalculator';
import BenefitsList from './components/BenefitsList';
import CTASection from './components/CTASection';
import { useLanguage } from '@/contexts/LanguageContext';

import FooterWrapper from '@/components/common/FooterWrapper';

interface PriceData {
  year: number;
  goldPrice: number;
  silverPrice: number;
}

interface Benefit {
  id: number;
  title: string;
  description: string;
}

export default function WhyGoldAndSilverPage() {
  const { t } = useLanguage();

  const introData = {
    title: t('whyGoldSilver.title'),
    description: t('whyGoldSilver.intro.description'),
    highlightText: t('whyGoldSilver.intro.highlight')
  };

  const historicalData: PriceData[] = [
  {
    year: 1999,
    goldPrice: 8420,
    silverPrice: 142
  },
  {
    year: 2025,
    goldPrice: 78500,
    silverPrice: 890
  }];


  const benefits: Benefit[] = [
  {
    id: 1,
    title: t('whyGoldSilver.benefits.benefit1.title'),
    description: t('whyGoldSilver.benefits.benefit1.description')
  },
  {
    id: 2,
    title: t('whyGoldSilver.benefits.benefit2.title'),
    description: t('whyGoldSilver.benefits.benefit2.description')
  },
  {
    id: 3,
    title: t('whyGoldSilver.benefits.benefit3.title'),
    description: t('whyGoldSilver.benefits.benefit3.description')
  },
  {
    id: 4,
    title: t('whyGoldSilver.benefits.benefit4.title'),
    description: t('whyGoldSilver.benefits.benefit4.description')
  },
  {
    id: 5,
    title: t('whyGoldSilver.benefits.benefit5.title'),
    description: t('whyGoldSilver.benefits.benefit5.description')
  },
  {
    id: 6,
    title: t('whyGoldSilver.benefits.benefit6.title'),
    description: t('whyGoldSilver.benefits.benefit6.description')
  },
  {
    id: 7,
    title: t('whyGoldSilver.benefits.benefit7.title'),
    description: t('whyGoldSilver.benefits.benefit7.description')
  }];


  return (
    <>
      <Header />
      <main className="min-h-screen bg-secondary relative overflow-hidden">
        <div className="mx-auto max-w-content px-6 lg:px-8 py-16 lg:py-20">
          <IntroStatement
            title={introData.title}
            description={introData.description}
            highlightText={introData.highlightText} />

          
          <HistoricalDataComparison data={historicalData} />
          
          <InvestmentCalculator />
          
          <BenefitsList benefits={benefits} />
          
          <CTASection />
        </div>
      </main>
      <FooterWrapper />
    </>);

}